module.exports = __webpack_public_path__ + "static/media/ExamAdd.68ca2012.svg";